/**
 * Is this site on the public web right now? Twin of the gateway's
 * services/api-gateway/src/lib/site-served.ts — the rule the public resolver and the platform
 * admin's unpublish use — and tested against the SAME table of cases (siteServed.test.ts).
 *
 * - A non-primary site serves only when `active`.
 * - A PRIMARY site serves in any status except `unpublished` (taken down by the platform admin)
 *   and `archived`: the tenant's slug falls back to its primary, and a new site made primary
 *   starts in `draft`.
 *
 * - A `preview` site never serves on its own hosts: it is seen only on its private preview link
 *   until the owner pays.
 *
 * `live` is not a site status (it belongs to deployments), so it gets no special case.
 */
export function isSiteServed(site: { status?: string | null; is_primary?: unknown }): boolean {
  if (site.status === 'active') return true;
  if (site.status === 'preview') return false;
  if (!(site.is_primary === true || site.is_primary === 1)) return false;
  return site.status !== 'unpublished' && site.status !== 'archived';
}
